module.exports = __webpack_public_path__ + "img/semakan.d4919af9.png";